import { createSafeContext } from '@mews-framework/utils';
import { RecaptchaService } from './recaptchaService';

export const { RecaptchaServiceContextProvider } = createSafeContext<'RecaptchaServiceContext', RecaptchaService>(
    'RecaptchaServiceContext'
);
